module.exports = __webpack_public_path__ + "static/media/starfarmlogo.8779934b.png";